import { donorKeys } from '@/donor/query-keys';
import { isPrivateRoute } from './routes';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/i18n/language-context';
import { bootstrapSession } from './session';
import { cancelBrowserVerification } from './verification';
export function DonorRuntime(): null {
  const cache = useQueryClient();
  const { locale } = useLanguage();
  const location = useLocation();
  useEffect(() => {
    void bootstrapSession(locale);
  }, [locale]);
  useEffect(() => () => cancelBrowserVerification(), [location.pathname]);
  useEffect(() => {
    const clear = (): void => {
      cancelBrowserVerification();
      void cache.cancelQueries({ queryKey: donorKeys.protected });
      cache.removeQueries({ queryKey: donorKeys.protected });
    };
    window.addEventListener('giving:identity-changed', clear);
    return () => window.removeEventListener('giving:identity-changed', clear);
  }, [cache]);
  useEffect(() => {
    const sensitive = isPrivateRoute(location.pathname);
    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (sensitive || import.meta.env.MODE === 'staging') {
      if (!robots) {
        robots = document.createElement('meta');
        robots.name = 'robots';
        document.head.append(robots);
      }
      robots.content = 'noindex, nofollow, noarchive';
    } else robots?.remove();
  }, [location.pathname]);
  return null;
}
